import {
    ComponentConfig,
    LayoutTypes,
    ComponentType,
    FlexDirection,
    WidthMode,
} from "../services/types/ComponentTypes";

export const screen_2201_leave_management_summary: ComponentConfig[] = [
    {
        componentType: LayoutTypes.SCREEN_GROUP,
        title: "Leave Management",
        childComponents: [
            {
                componentType: LayoutTypes.GROUP,
                childComponents: [
                    {
                        componentType: ComponentType.INFO_CARDS,
                        apiname: "/pabws/hrms/leave/statistics",
                        cards: [
                            {
                                name: "Total Leaves",
                                bindValue: "total_leaves",
                                icon: "📅",
                                defaultValue: 0,
                                valueFormat: "number",
                                color: "#3B82F6",
                            },
                            {
                                name: "Pending",
                                bindValue: "pending_leaves",
                                icon: "⏳",
                                defaultValue: 0,
                                valueFormat: "number",
                                color: "#F59E0B",
                            },
                            {
                                name: "Approved",
                                bindValue: "approved_leaves",
                                icon: "✔",
                                defaultValue: 0,
                                valueFormat: "number",
                                color: "#10B981",
                            },
                            {
                                name: "Rejected",
                                bindValue: "rejected_leaves",
                                icon: "❌",
                                defaultValue: 0,
                                valueFormat: "number",
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        style: {
                            direction: FlexDirection.ROW,
                            justifyContent: "flex-end",
                        },
                        childComponents: [
                            {
                                componentType: ComponentType.BUTTON,
                                name: "Apply Leave",
                                Label: "Apply Leave",
                                onPressAction: "navigate_2202",
                                visibility: [2],
                                style: {
                                    backgroundColor: "var(--primary-green)",
                                    textColor: "#FFFFFF",
                                    padding: 12,
                                    borderRadius: 6,
                                    widthMode: WidthMode.WRAP,
                                },
                            },
                        ],
                    },
                    {
                        componentType: LayoutTypes.GROUP,
                        childComponents: [
                            {
                                componentType: LayoutTypes.GROUP,
                                childComponents: [
                                    {
                                        componentType: ComponentType.SUMMARY_LIST,
                                        titleValue: "leave_date",
                                        apiname: "leave_management_summary",
                                        Name: "leave_management_summary",
                                        TableName: "employee_leave",
                                        View: "view_leave_management",
                                        DisplayName: "Leave Records",
                                        SummeryActions: [
                                            {
                                                ActionType: "approve",
                                                Action: {
                                                    Action: "navigate_2212",
                                                    ScreenId: "2212",
                                                },
                                                ScreenId: "2212",
                                                Label: "Review",
                                                popup: true,
                                                visibility: [1],
                                                visibleForStatus: ["pending", "approved", "rejected"],
                                            },
                                        ],
                                        fields: [
                                            {
                                                IncludeLabel: true,
                                                Label: "Date",
                                                BindValue: "date_leave",
                                                Json_Attribute: "leave_date",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Employee",
                                                BindValue: "s_select_employee",
                                                Json_Attribute: "employee_name",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Branch",
                                                BindValue: "s_select_branch",
                                                Json_Attribute: "branch_name",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Leave Type",
                                                BindValue: "s_select_leave_type",
                                                Json_Attribute: "leave_type",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Start Date",
                                                BindValue: "date_start",
                                                Json_Attribute: "start_date",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "End Date",
                                                BindValue: "date_end",
                                                Json_Attribute: "end_date",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Total Days",
                                                BindValue: "txt_total_days",
                                                Json_Attribute: "total_days",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Reason",
                                                BindValue: "txt_reason",
                                                Json_Attribute: "reason",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Status",
                                                BindValue: "txt_status",
                                                Json_Attribute: "status",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Approved By",
                                                BindValue: "s_select_approved_by",
                                                Json_Attribute: "approved_by_name",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                            {
                                                IncludeLabel: true,
                                                Label: "Approved Date",
                                                BindValue: "date_approved",
                                                Json_Attribute: "approved_date",
                                                ControlType: "TextView",
                                                showInSummary: true,
                                            },
                                        ],
                                    },
                                ],
                            },
                            {
                                componentType: LayoutTypes.GROUP,
                                childComponents: [
                                    {
                                        componentType: ComponentType.LEAVE_BALANCE,
                                        apiname: "/g360/hrms/leave/balance",
                                        title: "Leave Balance",
                                        // @ts-ignore
                                        // ignoring missing types for leave balance properties if strict check fails
                                    },
                                ],
                            },
                        ],
                    },
                ],
            },
        ],
    },
];
